import React, { useEffect, useState } from "react";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import ProfileUSer from "assets/images/common/others/profile-user-img.png";
import { useLocation, useNavigate } from "react-router-dom";
import exploreEvents from "assets/images/common/others/exploreEvents.png";
import locationIcon from "assets/images/svgs/locationIcon.svg";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";

import { ReactComponent as LocationIocn } from "assets/images/common/svgs/locationIcon.svg";

import { siteRoutes } from "utils/helpers/enums/routes.enum";
import useUtils from "hooks/useUtils";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import { EventsFilterDTO } from "utils/helpers/models/users/events-filter.dto";
import useUsers from "containers/user-management/useHooks";
import { EventDTO } from "utils/helpers/models/common/event.dto";
import { useSelector } from "react-redux";
import { EVENT_STATUS } from "utils/helpers/enums/shared.enum";
import DataNotFound from "components/particles/table/data-not-found";
import SessionDateBadge from "components/NextSession/SessionDateBadge";


const AttendeEvents = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = location.state || {};
  const { getQueryParams } = useUtils();
  const params = getQueryParams();
  console.log(params?.id);

  const [filters, setFilters] = useState<EventsFilterDTO>(
    new EventsFilterDTO()
  );
  const { getEventsById } = useUsers();
  const [data, setData] = useState<EventDTO[]>([]);
  const { isLoading } = useSelector((state: any) => state.sharedReducer);


  const getAllEvents = (filterParams: EventsFilterDTO) => {
    const queryParams: any = { attendeeId: params?.id, status: EVENT_STATUS.JOINED };

    for (let key in filterParams) {
      if (key !== "params?.id" && filterParams[key]) {
        queryParams[key] = filterParams[key];
      }
    }

    getEventsById(setData, queryParams, setFilters);
  };

  useEffect(() => {
    getAllEvents(filters);
  }, []);

  const handleFilterChange = (event: any) => {
    const { name, value } = event.target;
    const updatedFilters = { ...filters };

    if (name === "isSession") {
      updatedFilters[name] = value === "" ? undefined : value === "true";
    }
    if (name === "isWorkshop") {
      updatedFilters[name] = value === "" ? undefined : value === "true";
    } else {
      updatedFilters[name] = value;
    }

    setFilters(updatedFilters);

    if (name !== "searchTitle") {
      getAllEvents(updatedFilters);
    }
  };

  console.log(data);

  const goToBack = () => {
    navigate(-1);
  };


  const goToEventDetail = (id: number, user: any) => {
    navigate(`${siteRoutes.attendeeEventsDetail}?id=${id}`, { state: { user } });
  };

  return (
    <div>
      <h1 className="text-base text-primaryText font-bold mb-6 flex items-center gap-3">
        <span
          onClick={goToBack}
          className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
        >
          <ArrowBackIcon />
        </span>
        {`${user?.user?.firstName} ${user?.user?.lastName}`}’ Profile
      </h1>
      <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-6">
        <div className="flex justify-between items-center flex-wrap gap-4">
          <div className="flex justify-start items-center gap-2 ">
            <span>
              <img className="w-[82px] h-[82px] rounded-full" src={
                user?.user?.profilePicUrl
                  ? concatPathWithBackendUrl(
                    user?.user?.profilePicUrl?.fileDownloadUri
                  )
                  : editProfilePicUser
              } />
            </span>
            <span>
              <h2 className="text-base whitespace-nowrap font-bold text-primaryText">
                {`${user?.user?.firstName} ${user?.user?.lastName}`}
              </h2>
              <p className="text-xs font-medium text-primaryText">
                {user?.user?.firstName} family
              </p>
            </span>
          </div>
          <div className="flex items-center gap-4">
            <div className="">
              <select
                name="isSession"
                value={filters.isSession ?? ""}
                onChange={handleFilterChange}
                className="px-3 border border-lightGrayBorder text-primaryText outline-none rounded-lg text-sm h-[46px] w-full sm:w-auto min-w-[140px]"
              >
                <option value="">Event Type</option>
                <option value="true">Session</option>
                <option value="false">Workshop</option>
              </select>
            </div>

          </div>
        </div>

        <div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 my-6">
            {data.map((exp: EventDTO, index: number) => (
              <div
              onClick={() => goToEventDetail(exp?.id, user)}
                key={index + 1}
                className="p-3 bg-white rounded-xl border border-borderColor cursor-pointer"
              >
                <div className="relative">
                  <img
                    src={concatPathWithBackendUrl(
                      exp.eventPicsUrl![0]?.fileDownloadUri
                    )}
                    alt={exp.title}
                    className="w-full h-32 object-cover rounded-xl"
                  />
                   <div className="">
                <SessionDateBadge sessions={exp?.workshopSessions || []} />
                </div>
                </div>
                <div className="py-2">
                  <h3 className="text-sm font-semibold text-blackie">
                    {exp.title}
                  </h3>
                  <div className="flex items-center mt-2">
                    {/* <div className="flex -space-x-2">
                                    {[].map((avatar, index) => (
                                            <img
                                                key={index}
                                                src={avatar}
                                                alt="Attendee"
                                                className="w-7 h-7 rounded-full border-2 border-white"
                                            />
                                        ))}
                                  </div> */}
                    <span className="ml-2 text-xs text-darkYellowText">
                      {`${exp?.joineeSlots - exp?.availableSlots}`} + Going
                    </span>
                  </div>
                  <div className="text-xs text-[#807A7A] mt-2 flex items-start gap-2">
                    <div>
                      <LocationIocn className="w-4" />
                    </div>
                    <span>
                      {exp.location}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="">
          <DataNotFound show={!isLoading && !data.length} />
        </div>
      </div>

    </div>
  );
};

export default AttendeEvents;
